// RamsPage — top-level /app/rams wrapper: Requests dashboard (default) + Templates tab
// (internal staff only — template management isn't a portal capability).
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import RamsDashboardPage from "./RamsDashboardPage";
import RamsTemplatesPage from "./RamsTemplatesPage";
import RamsRegisterTab from "./RamsRegisterTab";

const INTERNAL_ROLES = new Set(["director", "administrator", "consultant"]);
const TABS = [["requests", "Requests"], ["register", "Sign-On Register"], ["templates", "Templates"]];

export default function RamsPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const { user } = useAuth();
    const isInternal = user && INTERNAL_ROLES.has(user.role);
    const tabs = isInternal ? TABS : TABS.filter(([id]) => id !== "templates");
    const initial = location.pathname.includes("/templates") ? "templates" : location.pathname.includes("/register") ? "register" : "requests";
    const [tab, setTab] = useState(initial);

    return (
        <div data-testid="rams-page">
            {tabs.length > 1 && (
                <div className="flex items-center gap-1 mb-5 border-b border-[#E5E0DA]">
                    {tabs.map(([id, label]) => (
                        <button key={id} data-testid={`rams-tab-${id}`}
                            onClick={() => { setTab(id); navigate(id === "templates" ? "/app/rams/templates" : id === "register" ? "/app/rams/register" : "/app/rams"); }}
                            className={`px-4 py-2.5 text-sm font-semibold border-b-2 -mb-px transition-colors ${tab === id
                                ? "border-[var(--brand-accent,_#C75A1B)] text-[#1F1F1F]"
                                : "border-transparent text-[#9A968F] hover:text-[#1F1F1F]"}`}>
                            {label}
                        </button>
                    ))}
                </div>
            )}
            {tab === "templates" && isInternal ? <RamsTemplatesPage /> : tab === "register" ? <RamsRegisterTab /> : <RamsDashboardPage />}
        </div>
    );
}
